import { Navigate, Outlet, useLocation } from 'react-router-dom';
import type { JSX } from 'react';
import { useBrandOffersAdminAuth } from '@/contexts/BrandOffersAdminAuthContext';

export const ADMIN_LOGIN_PATH = '/login' as const;

export function AdminRoutes(): JSX.Element {
  const { signed } = useBrandOffersAdminAuth();
  const location = useLocation();

  if (!signed) {
    return (
      <Navigate
        replace
        to={ADMIN_LOGIN_PATH}
        state={{ from: location.pathname }}
      />
    );
  }

  return <Outlet />;
}
